var map = {
	"./custom/app/header/header.component": [
		"tppE",
		61
	],
	"./dspace/app/header/header.component": [
		"acxG",
		44
	],
	"./wetoverlay/app/header/header.component": [
		"L+9V",
		100
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "M7g8";
module.exports = webpackAsyncContext;